import UserPendingSvg from "@icons/user-pending.svg?react";
import { Trans } from "@lingui/react/macro";

import { useCompany } from "@/common/providers/company-provider";
import { TwoColumnLayout } from "@/routes/layout/layout";

const PendingUserBanner = ({ children }: React.PropsWithChildren) => {
  const isPending = useIsPendingUser();

  if (!isPending) {
    return children;
  }

  return (
    <TwoColumnLayout
      left={{
        content: (
          <Box>
            <Message />
          </Box>
        ),
        header: null,
      }}
      noOutlet
      right={false}
    />
  );
};

const Box = ({ children }: React.PropsWithChildren) => (
  <div className="sm:left-[72px] mt-12 sm:mt-4 mx-auto md:max-w-[450px]">
    <div className="bg-[#fff2db] shadow-can-light-box px-6 py-3 flex rounded-lg items-center gap-4">
      {children}
    </div>
  </div>
);

const Banner = ({ children }: React.PropsWithChildren) => (
  <div className="w-full text-xs">
    <div className="bg-[#fff2db] px-4 py-1 flex rounded-lg items-center gap-4">
      {children}
    </div>
  </div>
);

const Message = () => (
  <>
    <UserPendingSvg className="shrink-0" />
    <p className="text-[#c28519] py-3">
      <Trans>
        <strong>Ověřujeme váš profil.</strong> Některé funkce mohou být omezeny
        do doby, než váš profil plně ověříme. Pro více informací nás můžete
        kontaktovat na e-mailové adrese:{" "}
        <a
          className="text-[#C28519] underline"
          href="mailto:support@cleverfarm.ag"
        >
          support@cleverfarm.ag
        </a>
        .
      </Trans>
    </p>
  </>
);

const useIsPendingUser = () => {
  const { company } = useCompany();

  if (!company) {
    return false;
  }

  return company.approvalState === "WAITING";
};

PendingUserBanner.Message = Message;
PendingUserBanner.Box = Box;
PendingUserBanner.Banner = Banner;

export { PendingUserBanner, useIsPendingUser };
